/**
 * @generated SignedSource<<c7369cb18ca1abc39ebec8b4cec57873>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AvailabilitySlotsButton_facility$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonPatronAccess_facility">;
  readonly " $fragmentType": "AvailabilitySlotsButton_facility";
};
export type AvailabilitySlotsButton_facility$key = {
  readonly " $data"?: AvailabilitySlotsButton_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvailabilitySlotsButton_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvailabilitySlotsButton_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityLessonPatronAccess_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "736b241e19316534a058f8214ce3920a";

export default node;
